import Vue from 'vue'
// import api from '@/api'

const Chargebee = window.Chargebee

// Guard: the CDN script (public/index.html) can be blocked by ad-blockers or
// strict CSPs — without this check the whole app fails to mount on any page.
if (Chargebee) {
  Chargebee.init({
    site: process.env.VUE_APP_CHARGEBEE_SITE_NAME
  })

  Vue.prototype.$chargebee = Chargebee.getInstance()
} else {
  console.warn('Chargebee script not loaded — $chargebee is unavailable')
}
